export default Object.freeze({
  TITLE: '상품이미지 대량등록 관리',
  TAB_TITLE: '상품이미지 대량등록',
  TAB_TITLE_2: '상품이미지 대량등록 현황',
  NOTICE: '저작권 등 다른 사람의 권리를 침해하는 사진은 관련 법규에 의해 제재를 받을 수 있습니다.',
  NOTICE_2: '이미지 등록 시, 이미지 파일 개수가 많거나 용량이 크면 업로드 완료까지 시간이 오래 걸릴 수 있습니다.',
  NOTICE_3: '상품이미지 대량등록 탭에서 등록한 이미지 파일에 대해 등록 성공/실패 현황 확인 할 수 있습니다.',

  UPLOAD_GUIDE_TITLE: '이미지 등록 가이드',
  UPLOAD_GUIDE_MESSAGE: '상품의 이미지 여러장을 일괄로 등록이 가능합니다.',
  UPLOAD_GUIDE_MESSAGE_2: '(항목별 이미지 파일당 최대 용량 확인 후 올려주세요.)',
  UPLOAD_GUIDE_MESSAGE_3: '대량 등록이 가능한 이미지는 상품 이미지 (대표이미지, 추가이미지), 리스트 이미지, 상품상세(상단,중간,하단) 이미지를 등록할 수 있습니다.',
  UPLOAD_GUIDE_MESSAGE_4: '이미지 항목+파일명 설정으로 이미지를 등록할 경우, 상품번호/상품관리코드 뒤의 숫자 규칙에 맞는 이미지 파일만 업로드 가능합니다.',
  UPLOAD_GUIDE_MESSAGE_5: '이미지 항목+파일명 설정으로 이미지를 등록할 경우, 이미지 항목별 업로드 이후 이미지 등록 버튼을 눌러야 최종적으로 이미지 등록요청이 완료 됩니다.',
  UPLOAD_GUIDE_MESSAGE_6: '파일명 설정으로 이미지를 등록할 경우, 파일명 설정 규칙에 맞는 이미지 파일만 업로드 가능합니다.',
  UPLOAD_GUIDE_MESSAGE_7: '파일명은 상품번호 or 상품관리코드 중에 1개의 기준으로 설정하여 등록할 수 있습니다.',
  UPLOAD_GUIDE_MESSAGE_8: '파일명을 상품관리코드로 설정 후 이미지 등록할 경우, 동일한 상품관리코드 전체에 등록됩니다.',
  UPLOAD_GUIDE_MESSAGE_9: '상품이미지 대량등록은 개별 파일, 폴더별로 업로드가 가능하며, zip파일은 업로드가 불가합니다.',
  UPLOAD_GUIDE_MESSAGE_10: '지원하는 파일 형식: JPG, JPEG, GIF, PNG, BMP',

  SETTING_TITLE: '상품이미지 업로드 방법 / 파일명 설정',
  SETTING_UPLOAD: '이미지 업로드 방법',
  SETTING_UPLOAD_ITEM: '파일명',
  SETTING_UPLOAD_ITEM_2: '이미지 항목 + 파일명',
  SETTING_UPLOAD_ITEM_3: '이미지항목 + 파일명',
  SETTING_FILENAME: '파일명 설정',
  SETTING_FILENAME_ITEM: '상품번호',
  SETTING_FILENAME_ITEM_2: '상품관리코드',

  FILENAME_GUIDE_TITLE: '상품 이미지 파일 설정 규칙',

  GUIDE_IMAGE: '이미지 항목',
  GUIDE_MAX_NUMBER: '가능 개수',
  GUIDE_MAX_SIZE: '파일 최대 용량',
  GUIDE_RULE: '파일명 설정 규칙',
  GUIDE_EXAMPLE: '파일명 예시',

  GUIDE_IMAGE_1: '대표 이미지 (상품 이미지)',
  GUIDE_IMAGE_2: '추가 이미지 (상품 이미지)',
  GUIDE_IMAGE_3: '리스트 이미지',
  GUIDE_IMAGE_4: '상품 상세 (상단)',
  GUIDE_IMAGE_5: '상품 상세',
  GUIDE_IMAGE_6: '상품 상세 (하단)',

  GUIDE_MAX_NUMBER_1: '1개',
  GUIDE_MAX_NUMBER_9: '9개',
  GUIDE_MAX_NUMBER_10: '10개',

  GUIDE_MAX_SIZE_1: '1MB',
  GUIDE_MAX_SIZE_1_2: '1MB (개당)',
  GUIDE_MAX_SIZE_10: '10MB',
  GUIDE_MAX_SIZE_10_2: '10MB (개당)',

  GUIDE_RULE_PREFIX: '상품번호/상품관리코드_',
  GUIDE_RULE_POSTFIX_ADD: 'add_숫자',
  GUIDE_RULE_POSTFIX_TOP: 'top_숫자',
  GUIDE_RULE_POSTFIX_DETAIL: 'detail_숫자',
  GUIDE_RULE_POSTFIX_DOWN: 'down_숫자',

  GUIDE_EXAMPLE_SUB: '(숫자는 1~9까지 가능, 숫자 순서대로 등록됨)',

  INDIVIDUAL_GUIDE_TITLE: '이미지 항목+파일명 업로드 요청 설정',
  INDIVIDUAL_GUIDE_UPLOAD: '업로드 요청',
  INDIVIDUAL_GUIDE_UPLOAD_LENGTH: '업로드 요청개수',
  INDIVIDUAL_GUIDE_IMAGE: '상품 이미지 (대표이미지+추가이미지)',
  INDIVIDUAL_GUIDE_SAME_IMAGE: '상품이미지와 동일한 이미지로 등록',

  FILENAME_GUIDE_SUB_TITLE: '상품이미지 파일명 설정 규칙',
  FILENAME_GUIDE_SUB_TITLE_2: '파일명 설정 규칙 / 파일명 설정 예시',
  FILENAME_GUIDE_MESSAGE: '파일을 여러 개 올릴 수 있는 업로드 항목의 경우, 파일명을 상품번호/상품관리코드-숫자로 설정하여 업로드 할 수 있습니다.',
  FILENAME_GUIDE_MESSAGE_2: '숫자는 0~9까지 입력 가능하며, 이미지 순서는 숫자 순서대로 등록됩니다.',
  FILENAME_GUIDE_MESSAGE_3: '상품이미지(대표이미지+추가이미지)의 경우에는 대표이미지를 숫자 0 으로, 추가이미지는 숫자 1~9 로 설정해 주세요.',
  FILENAME_GUIDE_MESSAGE_4: '상품상세(상단), 상품상세, 상품상세(하단)의 경우에는 숫자 1~9 로 설정해 주세요.',
  FILENAME_GUIDE_MESSAGE_5: '다수 이미지 등록 규칙 (ex,상품이미지(대표이미지+추가이미지), 상품상세(상단), 상품상세, 상품상세(하단)',
  FILENAME_GUIDE_MESSAGE_6: '* 파일명 설정 규칙 : 상품번호/상품관리번호-숫자(0~9)',
  FILENAME_GUIDE_MESSAGE_7: '* 파일명 설정 예시 : 12345-0',
  FILENAME_GUIDE_MESSAGE_8: '상품상세',
  FILENAME_GUIDE_MESSAGE_9: '상품이미지 (대표이미지+추가이미지)와 동일한 이미지로 등록으로 체크할 경우, 상품상세 이미지를 등록하지 않아도 대표이미지와 추가이미지를 합쳐서 상품상세 이미지로 등록합니다.',

  BUTTON_UPLOAD: '업로드',
  BUTTON_RESET: '초기화',
  BUTTON_REGISTER: '이미지 등록',

  FAIL_GUIDE_MESSAGE: '이미지 등록 현황 및 실패 사유는 ',
  FAIL_GUIDE_MESSAGE_2: '상품이미지 대량등록 현황 탭',
  FAIL_GUIDE_MESSAGE_3: '에서 확인해 주세요.',

  MAX_NUMBER_UNIT: '개',

  ALL_TEXT: '총 ',
  IMAGE_IN: '개의 이미지 중 ',
  OVER: '개가 등록요청 되었습니다.',

  ALERT_UPLOAD_INDIVIDUAL: '업로드 후 아래 이미지 등록 버튼을 눌러야 최종 이미지 업로드 요청이 됩니다.',
  ALERT_REQUEST_PRODUCT_IMAGE: '상품이미지(대표이미지+추가이미지)를 먼저 업로드 요청해 주세요.',

  CONFIRM_RESET_INDIVIDUAL: '선택하신 항목의 업로드 요청된 파일은 모두 삭제됩니다. 초기화 하시겠습니까?',

  SEARCH_WORD: '검색어',
  SEARCH_WORD_TYPE1: '상품번호',
  SEARCH_WORD_TYPE2: '상품관리코드',
  SEARCH_WORD_TYPE3: '상품명',
  SEARCH_WORD_PLACEHOLDER: '복수 상품 검색이 가능합니다. (Enter 또는 \',\'로 구분)',
  SEARCH_PERIOD: '기간',
  SEARCH_PERIOD_TYPE: '이미지등록일',
  SEARCH_PROGRESS: '진행상태',
  SEARCH_PROGRESS_TYPE_ALL: '전체선택',
  SEARCH_PROGRESS_TYPE_READY: '대기',
  SEARCH_PROGRESS_TYPE_PROGRESS: '진행중',
  SEARCH_PROGRESS_TYPE_FINISHED: '완료',

  RESULT: '조회결과 총',
  ADMIN_NAME: '등록자',
  DETAIL: '현황상세',
  ALL: '전체',
  EXCEL_DOWNLOAD: '엑셀 다운로드',
  INVALID_KEYWORD: '숫자와 콤마만 입력할 수 있습니다',

  GUIDE_POPUP_TITLE: '상품이미지 대량등록 업로드 방법 가이드',

  GUIDE_POPUP_FILENAME_TITLE: '1) 파일명 선택',
  GUIDE_POPUP_FILENAME_MESSAGE_1: '이미지 항목별로 파일명 설정 규칙에 맞는 이미지 파일만 업로드 가능합니다. (항목별 다수의 이미지 업로드가 가능한 경우, 파일명 규칙이 맞아야 업로드가 가능)',
  GUIDE_POPUP_FILENAME_MESSAGE_2: '파일명 규칙에 맞게 변경한 파일들은 한 번에 복수의 상품번호/상품관리코드의 파일을 업로드 할 수 있습니다.',

  GUIDE_POPUP_TABLE_CHECK: '체크 항목',
  GUIDE_POPUP_TABLE_MAIN_IMAGE: '대표이미지',
  GUIDE_POPUP_TABLE_SUB_IMAGE: '추가이미지',
  GUIDE_POPUP_TABLE_LIST_IMAGE: '리스트이미지',
  GUIDE_POPUP_TABLE_DETAIL_TOP: '상품상세(상단)',
  GUIDE_POPUP_TABLE_DETAIL_BOTTOM: '상품상세(하단)',
  GUIDE_POPUP_TABLE_FILE_TYPE: '지원하는 파일 형식',
  GUIDE_POPUP_TABLE_FILE_TYPE_2: 'JPG, JPEG, GIF, PNG, BMP',
  GUIDE_POPUP_TABLE_MAX_FILE_SIZE: '최대 용량 (파일 1개당)',
  GUIDE_POPUP_TABLE_MAX_FILE_NUMBER: '최대 이미지 등록 가능 개수',
  GUIDE_POPUP_TABLE_PRODUCT_NUMBER: '상품번호 or 상품관리코드',
  GUIDE_POPUP_TABLE_PRODUCT_NUMBER_2: '해당 SA에 속해있는 쇼핑몰의 상품번호 or 상품관리코드만 상품정보 업데이트함',
  GUIDE_POPUP_TABLE_PRODUCT_NUMBER_3: '상품번호/상품관리코드',
  GUIDE_POPUP_TABLE_PRODUCT_STATUS: '상품상태',
  GUIDE_POPUP_TABLE_PRODUCT_STATUS_2: '상품상태 中 삭제요청, 판매금지, 판매종료 제외하고 수정 가능',
  GUIDE_POPUP_TABLE_FILENAME_RULE: '파일명 규칙',
  GUIDE_POPUP_TABLE_FILENAME_RULE_2: '상품번호/상품관리코드와 항목과 숫자의 사이는 <span style="color: red">‘ _ (언더바)’</span>입니다.<br>(숫자는 <span style="color: red">1~9</span>까지 가능, 숫자 순서대로 등록됨)',
  GUIDE_POPUP_TABLE_PRODUCT_IMAGE: '상품이미지(대표이미지+추가이미지)',
  GUIDE_POPUP_TABLE_MAX_FILE_NUMBER_2: '<span style="color: red">10개</span><br>(대표이미지 1개, 추가이미지: 9개)',
  GUIDE_POPUP_TABLE_FILENAME_RULE_3: '상품번호/상품관리코드-<span style="color: red">숫자</span><br><span style="color: red">(대표이미지: 0 , 추가이미지: 1~9)</span>',
  GUIDE_POPUP_TABLE_FILENAME_RULE_4: '상품번호/상품관리코드-<span style="color: red">숫자</span><br><span style="color: red">(상품상세: 1~9)</span>',
  GUIDE_POPUP_TABLE_FILENAME_RULE_5: '상품번호/상품관리코드와 항목과 숫자의 사이는 <span style="color: red">‘ – (하이픈)’</span>입니다.<br>(숫자는 <span style="color: red">1~9</span>까지 가능, 숫자 순서대로 등록됨)',

  GUIDE_POPUP_IMAGE_TITLE: '2) 이미지항목 + 파일명 선택',
  GUIDE_POPUP_IMAGE_MESSAGE_1: '다수의 이미지를 함께 올릴 경우에는 이미지 항목을 선택 후, 상품번호/상품관리코드 뒤의 숫자 규칙에 맞는 이미지 파일만 업로드 가능합니다. (복수의 상품번호/상품관리코드도 한 번에 업로드 가능)',
  GUIDE_POPUP_IMAGE_MESSAGE_2: '이미지 항목별로 체크한 후, 업로드를 하고 나서 이미지 등록 버튼을 눌러야 최종적으로 이미지 등록 요청이 완료 됩니다.',

});
